import { useSyncExternalStore } from 'react';

/**
 * CORE-1659 — открыто ли окно «Настройки cookie».
 *
 * Окно одно на приложение и смонтировано в корне, а открывают его из разных
 * мест: баннер, футер (гость), настройки профиля. Обычный модуль без провайдера,
 * как `cookieBannerInset`: состояние — один флаг.
 */

let open = false;
const listeners = new Set<() => void>();

function set(next: boolean): void {
  if (open === next) return;
  open = next;
  listeners.forEach((listener) => listener());
}

export function openCookiePreferences(): void {
  set(true);
}

export function closeCookiePreferences(): void {
  set(false);
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function read(): boolean {
  return open;
}

export function useCookiePreferencesOpen(): boolean {
  return useSyncExternalStore(subscribe, read, read);
}
